import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'neq-home-page',
  templateUrl: './home.page.html'
})
export class NeqHomePage implements OnInit {
  
  ngOnInit() {
    // Required
  }
}
